<template>
  <div class="alice-pageheader">
    <div class="alice-pageheader__pattern" aria-hidden="true">
      <VP1Pattern :size="56" :opacity="0.08" />
    </div>
    <div class="alice-pageheader__inner">
      <div class="alice-pageheader__breadcrumb">
        <span>Workspace</span>
        <Icon name="chevron-right" :size="12" />
        <span>UX Research</span>
      </div>
      <h1 class="alice-pageheader__title">
        {{ title }}
        <span v-if="count != null" class="alice-pageheader__count">{{
          count
        }}</span>
      </h1>
      <p v-if="subtitle" class="alice-pageheader__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon.vue";
import VP1Pattern from "./VP1Pattern.vue";

export default {
  name: "AlicePageHeader",
  components: { Icon, VP1Pattern },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    count: { type: Number, default: null },
  },
};
</script>

<style scoped>
.alice-pageheader {
  position: relative;
  background: var(--vp-white);
  padding: 20px 32px 18px;
  border-bottom: 1px solid var(--border-hairline);
  overflow: hidden;
}
.alice-pageheader__pattern {
  position: absolute;
  right: -40px;
  top: -20px;
  width: 280px;
  height: 180px;
  pointer-events: none;
}
.alice-pageheader__inner {
  position: relative;
}
.alice-pageheader__breadcrumb {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--fg-3);
}
.alice-pageheader__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: var(--vp-black);
}
.alice-pageheader__count {
  display: inline-block;
  margin-left: 12px;
  font-family: var(--font-ui);
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-3);
  vertical-align: middle;
}
.alice-pageheader__subtitle {
  margin: 4px 0 0;
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--fg-2);
  max-width: 720px;
  line-height: 1.5;
}
</style>
